import React, { useState } from "react";
import PersonalDetails from "../PersonalDetaills/PersonalDetails";
import AddressDetails from "../AddressDetails/Addressdetails";
import EducationDetails from "../EducationDetails/EducationDetails";
import ExperienceDetails from "../ExperienceDetails/Experiencedetails";
import BankDetails from "../BankDetails/Bankdetails";
import IDDetails from "../IdDetails/IDDetails";
import PreviewPage from "../EmployeePreview/PreviewPage";
import "./RegistrationNavbar.css";
import Certifications from "../OtherCertificates/Certifications";

// ==============================|| BUTTON ||============================== //

const RegistrationNavbar = () => {
  const [activeSection, setActiveSection] = useState("personal-details");

  // Handle the "Next" button click
  const handleNext = () => {
    if (activeSection === "personal-details")
      setActiveSection("address-details");
    if (activeSection === "address-details")
      setActiveSection("education-details");
    if (activeSection === "education-details")
      setActiveSection("other-certificates");
     if (activeSection === "other-certificates")
      setActiveSection("experience-details");
    if (activeSection === "experience-details")
      setActiveSection("bank-details");
    if (activeSection === "bank-details")
      setActiveSection("id-details");
    if (activeSection === "id-details")
      setActiveSection("preview-details");
  };

  // Handle the "Previous" button click
  const handlePrevious = () => {
    if (activeSection === "preview-details")
      setActiveSection("id-details")
    if (activeSection === "id-details")
      setActiveSection("bank-details");
    if (activeSection === "bank-details")
      setActiveSection("experience-details");
    if (activeSection === "experience-details")
      setActiveSection("other-certificates");
      if (activeSection === "other-certificates")
      setActiveSection("education-details");
    if (activeSection === "education-details")
      setActiveSection("address-details");
    if (activeSection === "address-details")
      setActiveSection("personal-details");
  };

  return (
    <React.Fragment>
      <div className="employee-registration-container">
        <nav className="employeedetails-navbar">
          <ul>
            <li
              className={activeSection === "personal-details" ? "active" : ""}
              onClick={() => setActiveSection("personal-details")}
            >
              Personal Details
            </li>
            <li
              className={activeSection === "address-details" ? "active" : ""}
              onClick={() => setActiveSection("address-details")}
            >
              Address Details
            </li>
            <li
              className={activeSection === "education-details" ? "active" : ""}
              onClick={() => setActiveSection("education-details")}
            >
              Education Details
            </li>
            <li
              className={activeSection === "other-certificates" ? "active" : ""}
              onClick={() => setActiveSection("other-certificates")}
            >
              Other Certificates
            </li>
            <li
              className={activeSection === "experience-details" ? "active" : ""}
              onClick={() => setActiveSection("experience-details")}
            >
              Experience Details
            </li>
            <li
              className={activeSection === "bank-details" ? "active" : ""}
              onClick={() => setActiveSection("bank-details")}
            >
              Bank Details
            </li>

            <li
              className={activeSection === "id-details" ? "active" : ""}
              onClick={() => setActiveSection("id-details")}
            >ID Details
            </li>
            <li
              className={activeSection === "preview-details" ? "active" : ""}
              onClick={() => setActiveSection("preview-details")}
            >Preview
            </li>
          </ul>
        </nav>

        <div className="employeeregister-main-content">
          {activeSection === "personal-details" && (
            <PersonalDetails onNext={handleNext} />
          )}
          {activeSection === "address-details" && (
            <AddressDetails onNext={handleNext} onPrevious={handlePrevious} />
          )}
          {activeSection === "education-details" && (
            <EducationDetails onNext={handleNext} onPrevious={handlePrevious} />
          )}
          {activeSection === "other-certificates" && (
            <Certifications onNext={handleNext} onPrevious={handlePrevious} />
          )}
          {activeSection === "experience-details" && (
            <ExperienceDetails onNext={handleNext} onPrevious={handlePrevious} />
          )}
          {activeSection === "bank-details" && (
            <BankDetails onNext={handleNext} onPrevious={handlePrevious} />
          )}

          {activeSection === "id-details" && (
            <IDDetails onNext={handleNext} onPrevious={handlePrevious} />
          )}
          {activeSection === "preview-details" && (
            <PreviewPage onPrevious={handlePrevious} />
          )}


        </div>
      </div>
    </React.Fragment>
  );
};

export default RegistrationNavbar;
